/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventfeaturestitle2Inputs */

const en_eventfeaturestitle2 = /** @type {(inputs: Eventfeaturestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

const de_eventfeaturestitle2 = /** @type {(inputs: Eventfeaturestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionen`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Eventfeaturestitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventfeaturestitle2 = /** @type {((inputs?: Eventfeaturestitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventfeaturestitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventfeaturestitle2(inputs)
	return de_eventfeaturestitle2(inputs)
});
export { eventfeaturestitle2 as "eventFeaturesTitle" }